export function mmToPixels(mm: number, ppi: number, scaleFactor: number): number {
  const pixels = (mm * ppi) / 25.4;
  return pixels / scaleFactor;
}

export const getSelectedDeviceDimensions = ({
  devices,
  selectedDevice
}: {
  devices: Array<{ name: string; value: string }>;
  selectedDevice: string;
}) => {
  const device = devices.find(
    (device: { name: string; value: string }) => device.name === selectedDevice
  );

  if (device) {
    const [width, height, ppi, scaleFactor] = device.value.split(',');
    const resolution = `${width}x${height}`;

    return {
      resolution,
      width,
      height,
      ppi,
      scaleFactor
    };
  }
};
